import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import React from 'react';
import { FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import PlannerAssignmentStepHeader
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPostOnboardingWhatIsNext/PlannerAssignmentStepHeader';

function OnboardingPlannerAssignmentFinalizingMatch() {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  if (!resource) return null;

  return (
    <FDStack spacing={4} direction={'column'}>
      {resource.withRelationship(fr.relationships.lottie.name,
        (rel) => (
          <LottieLoadingLayout>
            <LottieRel relationship={rel} width={'250px'} height={'250px'} />
          </LottieLoadingLayout>
        ),
        () => null)}
      <PlannerAssignmentStepHeader resource={resource} />
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
      />
    </FDStack>
  );
}

export default OnboardingPlannerAssignmentFinalizingMatch;
